import isStrongPassword from 'validator/lib/isStrongPassword';
import User from '../../../resources/scripts/features/user-manager';

class BrixSetPasswordForm {
  static init(...parameters) {
    return new BrixSetPasswordForm(...parameters);
  }

  constructor(block) {
    this.form = block.querySelector('form');
    this.passwordInput = this.form.querySelector('input[name=password]');
    this.passwordInputErrorMsg = this.form.querySelector('.password-field-error');
    this.repeatPasswordInput = this.form.querySelector('input[name=repeat-password]');
    this.repeatPasswordInputErrorMsg = this.form.querySelector('.repeat-password-field-error');
    this.submitButton = this.form.querySelector('.submit');
    this.generalErrorMsg = this.form.querySelector('.error-message');
    this.token = this.getToken();

    this.submitButton.addEventListener('click', (event) => {
      this.resetPasswordEventHandler(event);
    });
  }

  getToken() {
    const urlObj = new URL(window.location.href);
    const query = new URLSearchParams(urlObj.search);
    return query.get('token') || null;
  }

  async resetPasswordEventHandler(event) {
    event.preventDefault();

    if (this.passwordInput.value === '') return;

    if (!this.token) {
      this.generalErrorMsg.classList.add('-visible');
      this.generalErrorMsg.innerText = this.generalErrorMsg.dataset.invalidLink;
      return;
    }

    // Password rules: minLength: 8, minLowercase: 1, minUppercase: 1, minNumbers: 1, minSymbols: 1
    if (!isStrongPassword(this.passwordInput.value)) {
      this.passwordInput.parentElement.classList.add('-error');
      this.repeatPasswordInput.parentElement.classList.remove('-error');
      this.generalErrorMsg.classList.remove('-visible');
      return;
    }

    if (this.passwordInput.value !== this.repeatPasswordInput.value) {
      this.repeatPasswordInput.parentElement.classList.add('-error');
      this.passwordInput.parentElement.classList.remove('-error');
      this.generalErrorMsg.classList.remove('-visible');
      return;
    }

    this.passwordInput.parentElement.classList.remove('-error');
    this.repeatPasswordInput.parentElement.classList.remove('-error');
    this.generalErrorMsg.classList.remove('-visible');

    const response = await User.setPassword({
      token: this.token,
      password: this.passwordInput.value,
    });

    if (response.error) {
      this.generalErrorMsg.classList.add('-visible');
      // 18 = invalid token
      if (response.error.code && response.error.code === '18') {
        this.generalErrorMsg.innerText = this.generalErrorMsg.dataset.invalidLink;
      } else {
        this.generalErrorMsg.innerText = this.generalErrorMsg.dataset.somethingWentWrong;
      }
    }
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-set-password-form', BrixSetPasswordForm.init);
}
